module.exports = __webpack_public_path__ + "img/mtn.27aa2273.png";